let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8hdz5")).then(() => parcelRequire('72x3t'));